export const trancatFileName = (fileName: string): string =>
  fileName.length > 18 ? `${fileName.substring(0, 16)}...${fileName.slice(-3)}` : fileName;
